<template>
  <v-container fluid>
    <v-layout>
      <v-flex class="margin-custom-width-left">
        <v-flex xs12 sm10 md6>
          <br />
          <v-alert
            :value="true"
            color="info"
            outline
          >If you are interested in one of our programs, sign-up below and we will get back to you shortly after.</v-alert>
          <br />
          <v-form ref="form" v-model="valid">
            <label class="headline">Application</label>
            <v-text-field
              prepend-icon="person"
              v-model="playerName"
              :rules="nameRules"
              label="Player Name"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="contact_mail"
              v-model="email"
              :rules="emailRules"
              label="Contact E-mail"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="phone"
              v-model="phone"
              :rules="phoneRules"
              label="Contact Phone"
              mask="phone"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="tab"
              v-model="clubName"
              :rules="clubRules"
              label="Current Club"
              required
            ></v-text-field>
            <v-select
              label="Age Group"
              prepend-icon="star"
              v-model="selectedAgeGroup"
              :rules="ageRule"
              :items="ageGroups"
              item-text="ageGroup"
              item-value="ageGroup"
            ></v-select>

            <v-select
              prepend-icon="directions_run"
              label="Position"
              v-model="selectedPosition"
              :rules="positionRule"
              :items="position"
            ></v-select>

            <v-select
              prepend-icon="event"
              label="Program"
              v-model="selectedProgram"
              :rules="programRule"
              :items="program"
            ></v-select>

            <v-select
              v-show="this.selectedProgram == 'Summer'"
              prepend-icon="calendar"
              label="Week"
              v-model="selectedWeek"
              :items="weeks"
              multiple
            ></v-select>

            <v-textarea prepend-icon="comment" v-model="comments" label="Note (optional)" required></v-textarea>

            <v-btn :disabled="!valid" @click="signUp()" color="primary">Apply</v-btn>
            <v-btn @click="clear" color="info">Clear</v-btn>
            <br />
            <br />
          </v-form>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :timeout="10000"
      multi-line
    >{{ snackbar.text }}</v-snackbar>
  </v-container>
</template>


<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import dataService from "@/data/data.service";

export default {
  data: () => ({
    snackbar: {
      text: "",
      visible: false,
      color: "success"
    },
    valid: true,
    selectedAgeGroup: null,
    selectedPosition: null,
    selectedProgram: null,
    selectedWeek: [],
    playerName: "",
    phone: null,
    clubName: null,
    nameRules: [v => !!v || "Name is required"],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    ageRule: [v => !!v || "Age Group is required"],
    positionRule: [v => !!v || "Position required"],
    programRule: [v => !!v || "Program is required"],
    clubRules: [v => !!v || "Club is required"],
    phoneRules: [v => !!v || "Phone is required"],
    comments: "",
    ageGroups: [2004, 2005, 2006, 2007],
    position: ["Field Player", "Goal Keeper"],
    program: ["Winter", "Year Round - Full", "Drop-in", "Summer - Closed"],
    weeks: [
      "Week 1 (7/1 - 7/7)",
      "Week 2 (7/8 - 7/14)",
      "Week 3 (7/15 - 7/21)",
      "Week 4 (7/22 - 7/28)",
      "Week 5 (7/29 - 8/4)",
      "Week 6 (8/5 - 8/11)",
      "Week 7 (8/12 - 8/18)",
      "Week 8 (8/19 - 8/25)"
    ]
  }),

  mounted() {
    //this.getAgeGroups();
  },

  methods: {
    signUp() {
      if (this.$refs.form.validate()) {
        //Post request needs token
        //Set default user/token
        if (this.selectedProgram == "Summer") {
          if (this.selectedWeek.length == 0) {
            this.snackbar.visible = true;
            this.snackbar.color = "error";
            this.snackbar.text = "You need to specify training week";
            return;
          }
        }

        let signUp = {
          playerName: this.playerName,
          email: this.email,
          ageGroup: this.selectedAgeGroup,
          position: this.selectedPosition,
          program: this.selectedProgram,
          comments: this.comments,
          program: this.selectedProgram,
          phone: this.phone,
          clubName: this.clubName,
          signUpDate: new Date().toJSON()
        };
        this.addSignUp(signUp).then(() => {
          this.sendEmail();
          this.valid = false;
          this.snackbar.visible = true;
          this.snackbar.color = "success";
          this.snackbar.text =
            "Thank you for your interest. We will be in touch with you shortly!";
        });
      }
    },

    sendEmail() {
      let env = process.env.NODE_ENV || "development";
      let config = require("../../config")[env];
      let emailObj = {
        from: "inquiry@fairfaxcityfutsal.com",
        to: config.email.recipient,
        subject: "New Player Sign-up",
        body:
          `Player: ${this.playerName} <br><br>` +
          `Email: ${this.email} <br><br>` +
          `Age Group: ${this.selectedAgeGroup} <br><br>` +
          `Position: ${this.selectedPosition} <br><br>` +
          `Club: ${this.clubName} <br><br>` +
          `Phone: ${this.phone} <br><br>` +
          `Program: ${this.selectedProgram} ${
            this.selectedProgram == "Summer" ? " - " + this.selectedWeek : ""
          } <br><br>` +
          `Comment: ${this.comments}`
      };
      dataService.modules.email.sendMail(emailObj);
    },

    clear() {
      this.$refs.form.reset();
    },

    ...mapActions("ageGroup", { getAgeGroups: "get" }),
    ...mapActions("signUps", { addSignUp: "add" })
  },

  computed: {
    //...mapGetters("ageGroup", ["ageGroups"])
  }
};
</script>